import React, { useContext, useEffect, useRef } from "react";
import dayjs from "dayjs";
import OccupantView from "../components/OccupantView";
import DriverVehicleView from "../components/DriverVehicleView";
import AdForm from "../components/AdForm";
import AppContext from "../context";
import WeatherIcon from "../components/WeatherIcon";
import { useTranslation } from "react-i18next";
import utc from "dayjs/plugin/utc";
dayjs.extend(utc);

export default function Accident({ a, blurred }) {
	const lc = (text) => {
		if (text) return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
		return "";
	};
	const { setModal } = useContext(AppContext);
	const popover = useRef();
	const { t } = useTranslation();

	useEffect(() => {
		document.getElementsByTagName("body")[0].id = "ACCIDENT";
	}, []);

	return (
		<div>
			<div className="container" id="accident-top">
				<a onClick={() => toggleMenu()}>
					<img src="/assets/icon-menu.svg" className="menu" />
				</a>
				<a href="/">
					<img src="/assets/logo.png" className="logo" />
				</a>
				<h1>
					myaccident<span>Report</span>
				</h1>
				<span>
					<strong>{t("CASE_ID")}: </strong>
					{a.caseID}
				</span>
				<span>
					<strong>{t("CRASH_ID")}: </strong>
					{a.crash_id}
				</span>
				<button
					onClick={() => setModal("download")}
					onMouseOver={() => popover.current.classList.add("show")}
					onMouseOut={() => popover.current.classList.remove("show")}
				>
					<img src="/assets/icon-download.svg" />
					{t("DOWNLOAD_FULL_REPORT")}
				</button>
				<div className="compensation-popover top-download-button" ref={popover}>
					{t("FREE_PDF__INCLUDES__VIN_AND_INSURANCE_INFO")}
				</div>
			</div>
			<div id="accident-header">
				<div className="container">
					<span>
						<strong>{t("LOCATION")}: </strong>
						{a.city && a.state && a.city !== "unknown"
							? a.city + ", " + a.state
							: a.location_address.replace("Unknown, ", "")}
					</span>
					<span>
						<strong>{t("DATE___TIME")}: </strong>
						{dayjs.utc(a.date).format("MM/DD/YY hh:mm A")}
					</span>
					<span>
						<strong>PD: </strong>
						<img
							alt={a.agency}
							src={a.badge_url ? a.badge_url : "/assets/logo.png"}
							className="badge"
							onError={(e) => {
								e.target.onerror = null;
								e.target.src = "/assets/logo.png";
							}}
						/>
						{a.agency}
					</span>
					<span>
						<strong>{t("VEHICLE_AT_FAULT")}: </strong> {a.at_fault}
					</span>
				</div>
			</div>
			<div className="container">
				<h1>{t("SUMMARY")}</h1>
				<div style={{ height: 30 }} />
				<div className="row">
					<div>
						<section>
							<img src="/assets/icon-car.svg" />
							<div>
								<strong>{t("ACCIDENT_CONTRIBUTING_FACTORS")}</strong>
								{a.accident_contributing_factors}
							</div>
						</section>
						<section>
							<img src="/assets/icon-date-time.svg" />
							<div>
								<strong>{t("DATE___TIME_OF_CRASH")}</strong>
								{dayjs.utc(a.date).format("MM/DD/YY hh:mm A")}
							</div>
						</section>
						<section>
							<img src="/assets/icon-speed-limit.svg" />
							<div>
								<strong>{t("SPEED_LIMIT")}</strong>
								{a.crash_speed_limit && a.crash_speed_limit !== -1
									? `${a.crash_speed_limit} MPH`
									: "unknown"}
							</div>
						</section>
						<section>
							<img src="/assets/icon-pd.svg" />
							<div>
								<strong>{lc(a.agency)}</strong>
								{a.agency_phone}
							</div>
						</section>
					</div>

					<div>
						<section className="aligned triangle">
							<img src="/assets/num.svg" />
							<span className="triangle-number">{a.total_injury_count}</span>
							<strong>{t("TOTAL_NUMBER_OF_INJURIES")}</strong>
						</section>

						<section className="aligned">
							<span className="circle">{a.vehicles.length}</span>
							<strong>{t("TOTAL_NUMBER_OF_VEHICLES")}</strong>
						</section>

						<section className="aligned">
							<span className="circle">{a.people_count}</span>
							<strong>{t("TOTAL_NUMBER_OF_OCCUPANTS")}</strong>
						</section>
						<section>
							<img src="/assets/icon-location.svg" />
							<div>
								<strong>{t("ACCIDENT_LOCATION")}</strong>
								{a.location_address}
							</div>
						</section>
					</div>
				</div>
				<div className="row">
					<div>
						<section>
							<img src="/assets/icon-description.svg" />
							<div>
								<strong>{t("DESCRIPTION")}</strong>
								{a.description}
								{a.summary}
								{a.narrative ? (
									<div>
										<br />
										<strong>{t("ADDITIONAL_NARRATIVE")}</strong>
										{a.narrative}
									</div>
								) : null}
							</div>
						</section>
					</div>
					<div style={{ position: "relative" }}>
						<img
							src={`https://maps.googleapis.com/maps/api/staticmap?center=${a.location_lat},${a.location_lng}&style=visibility:on&zoom=15&scale=1&size=640x480&maptype=roadmap&key=AIzaSyCb4X58O574pZiBot_hf3N9q_bGu9yO8i8&format=png&visual_refresh=true&markers=icon:hhttps://myaccident.org/images/location-pin-01.webp%7Cshadow:false%7C${a.location_lat},${a.location_lng}`}
							width="100%"
							height="100%"
							style={{ objectFit: "cover", minHeight: 300 }}
						/>
						{/* <div
							style={{
								width: "100%",
								height: "100%",
								background: "#CCC",
								minHeight: 300
							}}
						/> */}
						<div id="conditions">
							<div>
								<img
									src="/assets/icon-road.svg"
									alt="Weather and Traffic icon"
								/>
								<div>
									<strong>{t("ROAD___TRAFFIC_CONDITIONS")}</strong>
									{a.traffic_conditions}
								</div>
							</div>
							<div>
								<WeatherIcon a={a} />
								<div>
									<strong>{t("WEATHER")}</strong>
									{a.weather_conditions}
								</div>
							</div>
						</div>
					</div>
				</div>
				<div style={{ height: 50 }} />
				<h1>{t("OCCUPANT_INFORMATION")}</h1>

				<div style={{ height: 30 }} />

				<div className="occupant-form-holder">
					<div style={{ flex: 1 }}>
						{a.vehicles.map((v, k) => (
							<OccupantView v={v} key={v._id} k={k} />
						))}
					</div>
					{!blurred ? <AdForm a={a} /> : null}
				</div>

				<div style={{ height: 50 }} />
				<h1>{t("DRIVER___VEHICLE_INFORMATION")}</h1>
				<div style={{ height: 30 }} />
				{a.vehicles.map((v, k) => (
					<DriverVehicleView v={v} key={v._id} k={k} blurred={blurred} />
				))}
				<div style={{ maxWidth: 900, margin: "auto" }}>
					<h1>Online Driving Course</h1>
					<p>
						<br />
						Any time you are convicted of a traffic violation or are involved in
						a car accident, it will appear on your driving record. If you
						complete a defensive driving course for a citation, the ticket will
						be removed from your driving record, and your completion of a
						defensive driving course will be noted on your record.
						<br />
						<br />
						<a
							href="https://www.defensivedriving.com/"
							target="_blank"
							rel="noopener noreferrer"
						>
							<img src="/assets/OnlineDrivingCourse.jpg" width="100%" />
						</a>
					</p>
				</div>
			</div>
		</div>
	);
}
